import { render, staticRenderFns } from "./GestionKPIs.vue?vue&type=template&id=97955a5a&scoped=true"
import script from "./GestionKPIs.vue?vue&type=script&lang=js"
export * from "./GestionKPIs.vue?vue&type=script&lang=js"
import style0 from "./GestionKPIs.vue?vue&type=style&index=0&id=97955a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97955a5a",
  null
  
)

export default component.exports